import React from "react"
import tw, { styled, css, theme } from "twin.macro"
import Link from "next/link"
import { Routes } from "../../routes"
import { ReactComponent as LogoDefaultSVG } from "../../assets/logo/bonsai-default.svg"

const LogoDefault = styled(LogoDefaultSVG)(() => [
  tw`
    w-[118px]
    tablet:w-36
    tablet-lg:w-[158px]
  `,
  css`
    path {
      fill: ${theme(`colors.logo-color`)};
    }
  `,
])

interface MainLogoProps {
  linked?: boolean
}

export function MainLogo({ linked }: MainLogoProps) {
  if (!linked) {
    return (
      <>
        <span tw="sr-only">Bonsai</span>
        <LogoDefault />
      </>
    )
  }
  return (
    <Link href={{ pathname: Routes.Root }} passHref>
      <a data-testid="bonsai-logo" title="Bonsai" tw="block tablet-lg:(pr-2)">
        <span tw="sr-only">Bonsai</span>
        <LogoDefault />
      </a>
    </Link>
  )
}
